const formataPayloadValuesDeOption = ({ values, field }) => {
	const valor_tipo = values[field]?.id ?? null;
	return { [field]: valor_tipo ?? undefined };
};

export default formataPayloadValuesDeOption;
